// extracted by css-extract-rspack-plugin
export default {"dataListToolbar":"sMSC_HUpcw4BmyiT","dataListToolbarBorder":"M7XwvV9mAhoGg8eD"};